import { Person, PersonFieldsRowInfo } from 'entities/person';
import { OrderTags } from 'entities/orders/ui/InfoPanel/components/OrderInfo/OrderTags';
import { PersonVisitOrders } from 'features/orders/personVisitOrders';
import { FC } from 'react';
import {
	getOrdersByFilter,
	OrderPersonNotes,
	useOrderInfo,
} from 'entities/orders';
import { Flex } from 'shared/ui/flex';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import { ButtonText } from 'shared/ui/buttons/buttonText';
import { ButtonsContainer, Container, MarginBottom } from './styles';
import { WithPreloaderHOC } from 'shared/ui/spinner';
import { useModal } from 'shared/lib/modal';
import { PaginationFilterProvider } from 'shared/ui/pagination';

interface PersonModalCardContentProps extends WithPreloaderHOC {
	person: Person | null;
	hideBookingBtn?: boolean;
	onCloseModal: () => void;
	onBooking?: () => void;
	clearAllExceptPerson?: () => void;
	showOrderEdit?: boolean;
}

export const PersonModalCardContent: FC<PersonModalCardContentProps> = ({
	person,
	hideBookingBtn = false,
	onCloseModal,
	onBooking,
  clearAllExceptPerson,
	showOrderEdit,
}) => {
	const { openModal } = useModal();
	const { close } = useOrderInfo();

	const isContinueBooking = !showOrderEdit && onBooking;

	const openBook = async () => {
		close();
		openModal();
	};

	const clickHandler = async () => {
    if (!isContinueBooking) {
      await clearAllExceptPerson?.();
    }
		if (onBooking) {
			onBooking();
		} else {
			openBook();
		}
	};

	return (
		<>
			<div>
				<Container>
					<PersonFieldsRowInfo person={person} />
				</Container>

				<Container>
					<OrderTags
						tags={person?.tags || []}
						forOrder={false}
						title="Теги"
						textTagPointer={true}
						outputDashInsteadTags={true}
					/>
				</Container>

				<Container>
					<OrderPersonNotes
						person={person}
						variant={'default'}
						title="Комментарий"
						outputDashInsteadNotes={true}
					/>
				</Container>

				<MarginBottom>
					<PaginationFilterProvider fetchData={getOrdersByFilter}>
						<PersonVisitOrders title="История визитов" isContinueBooking={isContinueBooking ? true : false}/>
					</PaginationFilterProvider>
				</MarginBottom>
			</div>
			<ButtonsContainer>
				<Flex $justify="center" $direction="column" $gap="10px">
					{!hideBookingBtn && (
						<ButtonContained onClick={clickHandler}>
							{isContinueBooking
								? 'Продолжить бронирование'
								: 'Новое бронирование'}
						</ButtonContained>
					)}
					<ButtonText color={'danger'} onClick={onCloseModal}>
						Закрыть
					</ButtonText>
				</Flex>
			</ButtonsContainer>
		</>
	);
};
